export default __webpack_public_path__ + "blog02.jpg";